import { render, staticRenderFns } from "./ObjectSearchView.vue?vue&type=template&id=789ec053&"
import script from "./ObjectSearchView.vue?vue&type=script&lang=js&"
export * from "./ObjectSearchView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectSearchView.vue?vue&type=style&index=0&id=789ec053&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports